import { MANAGE_COUNTERS } from './manage-counters';
export const MANAGE_SECTIONS = [
    {
        id: 'setup',
        segment: 'kurulum',
        labelKey: 'organizer.navSetup',
        hintKey: 'manage.hintSetup',
    },
    {
        id: 'program',
        segment: 'ajanda',
        labelKey: 'organizer.navProgram',
        hintKey: 'manage.hintProgram',
    },
    {
        id: 'registrations',
        segment: 'kayitlar',
        labelKey: 'organizer.navRegistrations',
        hintKey: 'manage.hintRegistrations',
    },
    {
        id: 'invitations',
        segment: 'davetler',
        labelKey: 'organizer.navInvitations',
        hintKey: 'manage.hintInvitations',
        accessModes: ['invite_only', 'approval'],
    },
    {
        id: 'applications',
        segment: 'basvurular',
        labelKey: 'organizer.navApplications',
        hintKey: 'manage.hintApplications',
        accessModes: ['approval'],
        badgeCounter: 'pendingApplications',
    },
    {
        id: 'announcements',
        segment: 'duyurular',
        labelKey: 'organizer.navAnnouncements',
        hintKey: 'manage.hintAnnouncements',
        requiredPermission: 'announcement:manage',
    },
    {
        id: 'tickets',
        segment: 'biletler',
        labelKey: 'organizer.navTickets',
        hintKey: 'manage.hintTickets',
    },
    { id: 'areas', segment: 'alanlar', labelKey: 'organizer.navAreas', hintKey: 'manage.hintAreas' },
    /*
     * Etkinlik raporu (kapsam 25.10.2026, R1; Rapor 2, 27.10.2026). Analitik bölümü
     * KAPANDI ve içeriği buraya girdi (Canlı özet, §6 saatlik kayıt, §7 kırılımlar);
     * eski kimlik ve adres `RETIRED_MANAGE_SECTIONS` ile bu bölüme iner.
     */
    { id: 'report', segment: 'rapor', labelKey: 'organizer.navReport', hintKey: 'manage.hintReport' },
    /*
     * Katılım belgesi ve etkinlik sonrası anket (kapsam 25.10.2026, Story 2-3).
     * Her aktif üye görür: görüntüleyici salt okur, yazma `event:manage` ister (API).
     * Mobil kurum yüzeyi bu kapsamda YOK (kapsam md. 5).
     */
    {
        id: 'postEvent',
        segment: 'belge-anket',
        labelKey: 'organizer.navPostEvent',
        hintKey: 'manage.hintPostEvent',
    },
    {
        id: 'sponsor',
        segment: 'sponsor',
        labelKey: 'organizer.navSponsor',
        hintKey: 'manage.hintSponsor',
    },
    { id: 'brand', segment: 'marka', labelKey: 'organizer.navBrand', hintKey: 'manage.hintBrand' },
    {
        id: 'billing',
        segment: 'paket',
        labelKey: 'organizer.navBilling',
        hintKey: 'manage.hintBilling',
    },
];
/**
 * KAPANAN BÖLÜMLER (Rapor 2 Story 3, kullanıcı kararı 27.10.2026). Bölüm haritadan
 * silinir ama eski kimliği (mobil gezinme durumu, eski sürümün ürettiği rota) ve
 * eski adresi (web yer imi, e-posta bağlantısı, mobil derin bağlantı) ÇIKMAZ
 * SOKAĞA düşmez: yerini alan bölüme iner. Web adresini `next.config.ts`
 * `redirects()` kalıcı yönlendirir, mobil `resolveManageSectionId` ve
 * `manageSectionIdForSegment` ile çözer.
 */
export const RETIRED_MANAGE_SECTIONS = {
    analytics: { segment: 'analitik', replacement: 'report' },
};
/** Kimlik kapanan bir bölümünse yerini alan bölüm, değilse kendisi. */
export function resolveManageSectionId(id) {
    return id in RETIRED_MANAGE_SECTIONS
        ? RETIRED_MANAGE_SECTIONS[id].replacement
        : id;
}
/** Web adresindeki bölüm parçası → bölüm (kapanan bölümün eski adresi dahil); tanınmazsa `undefined`. */
export function manageSectionIdForSegment(segment) {
    const lowered = segment.toLowerCase();
    const live = MANAGE_SECTIONS.find((section) => section.segment === lowered);
    if (live)
        return live.id;
    return Object.values(RETIRED_MANAGE_SECTIONS).find((retired) => retired.segment === lowered)
        ?.replacement;
}
/** Panel kökü (`/manage`) bu bölüme yönlendirilir — eski adres kırılmaz. */
export const MANAGE_DEFAULT_SEGMENT = 'kayitlar';
/**
 * Erişim moduna göre görünür bölümler. Mod HENÜZ BİLİNMİYORSA (etkinlik künyesi
 * yüklenmedi) koşullu bölümler gizlenir — yanlış bölüm gösterip geri almaktansa
 * bir kare eksik göstermek doğrudur.
 */
export function visibleManageSections(accessMode, permissions = null) {
    return MANAGE_SECTIONS.filter((section) => isSectionVisible(section, accessMode) &&
        (!section.requiredPermission || (permissions?.includes(section.requiredPermission) ?? false)));
}
export function manageSection(id) {
    const section = MANAGE_SECTIONS.find((item) => item.id === id);
    if (!section)
        throw new Error(`unknown manage section: ${id}`);
    return section;
}
function isSectionVisible(section, accessMode) {
    return !section.accessModes || (accessMode !== null && section.accessModes.includes(accessMode));
}
const KPI_LABELS = {
    pendingApplications: 'manage.kpiPendingApplications',
    invitationsSent: 'manage.kpiInvitationsSent',
    attendees: 'manage.kpiAttendees',
};
/**
 * KPI ŞERİDİ `MANAGE_COUNTERS`TAN ÜRETİLİR (manuel test 2 · bulgu 1).
 *
 * Sayaç ile listesi arasındaki bağ artık BEYANLIDIR ve tek kaynaktadır: kutu,
 * saydığı satırları gösteren bölüme (ve filtreye) LİNKTİR. "2 bekleyen başvuru"
 * yazan kutuya basan organizatör tam o iki satırı görür — eskiden kutu ölü bir
 * `div`di ve kullanıcı sayıyı başka ekrandaki başka bir çiple eşleştirmeye
 * çalışıyordu.
 */
export const MANAGE_KPIS = MANAGE_COUNTERS.map((counter) => ({
    id: counter.id,
    section: counter.section,
    listStatus: counter.listStatus,
    labelKey: KPI_LABELS[counter.id],
}));
export function visibleManageKpis(accessMode) {
    return MANAGE_KPIS.filter((kpi) => {
        const section = MANAGE_SECTIONS.find((item) => item.id === kpi.section);
        return section !== undefined && isSectionVisible(section, accessMode);
    });
}
/**
 * KPI SAYACININ METNİ (QA Blok 16 P3 · mobil `CheckInScreen` sayacıyla aynı desen).
 *
 * Liste isteği düşünce dizi boş kalıyor ve başlıkta "0 bekleyen başvuru"
 * yazıyordu: organizatör kayıtların SİLİNDİĞİNİ sanabilir. BİLİNMEYEN SAYI
 * SIFIR DEĞİLDİR — hata ve ilk yükleme fazlarında "—" gösterilir.
 *
 * Tur T1'de web'den (`apps/web/.../event-manage-kpi.ts`) buraya taşındı: mobil
 * hub aynı şeridi çiziyor ve iki istemcinin "bilinmiyor" tanımı ayrışamaz.
 */
export function manageKpiValue(phase, value) {
    if (value === null || value === undefined)
        return '—';
    if (phase === 'succeeded')
        return String(value);
    // Tazeleme sırasında ELDEKİ sayı korunur, SIFIR DAHİL (mobil rozet QA P3:
    // eldeki 0 yenilemede "—" titriyordu). Hiç veri gelmediyse (`null`) ve
    // istek düştüyse sayı BİLİNMİYOR demektir.
    if (phase === 'loading')
        return String(value);
    return '—';
}
/**
 * BÖLÜM ROZETİNİN SAYISI — `null` ise rozet ÇİZİLMEZ.
 *
 * Sıfırda rozet yoktur (kullanıcı bulgusu 20.10). Bilinmeyen sayı da rozet
 * üretmez: hata ve ilk yükleme fazında "—" yazan bir rozet menüde gürültüdür,
 * uydurma sayı da gösterilmez (md. 9). Tazeleme sırasında eldeki pozitif sayı
 * korunur (`manageKpiValue` ile aynı kural), rozet karar sonrası titremez.
 * Web yan menüsü ve mobil hub aynı kuralı buradan okur.
 */
export function manageSectionBadgeCount(phase, value) {
    if (value === null || value <= 0)
        return null;
    if (phase === 'succeeded' || phase === 'loading')
        return value;
    return null;
}
//# sourceMappingURL=manage-sections.js.map